RCDPW.module('RCDPW.validator.rules.login', {
    user: {
        required: true,
        phoneNumber: true
    },
    extension: {
        ext: true
    },
    password: 'required'
});